/** Where a picture card can sit without covering the speaker: the free band above the face or between the face and the captions. */
export interface CardBox { top: number; height: number; width: number }

/** faceY / capTop are fractions of the frame height (capTop = where the captions block begins). Returns fractions/pixels for a 1080×1920 frame. */
export function cardPlacement(faceY: number | null, capTop: number, W = 1080, H = 1920): CardBox {
  const minH = 0.16, maxH = 0.34, ratio = 4 / 3;
  if (faceY == null) { const h = 0.3; return { top: 0.14 * H, height: h * H, width: Math.min(0.8 * W, h * H * ratio) }; }
  const bands: [number, number][] = [[0.04, faceY - 0.17], [faceY + 0.18, Math.max(faceY + 0.18, capTop - 0.02)]];
  const sized = bands.map(([a, b]) => ({ a, b, size: b - a }));
  // between the face and the captions reads most naturally; only go above the head when there is clearly more room there
  const best = sized[0].size > sized[1].size + 0.04 ? sized[0] : sized[1];
  const h = Math.max(minH, Math.min(maxH, best.size));
  const top = best.size >= h ? best.a + (best.size - h) / 2 : Math.max(0.03, Math.min(1 - h, best.a));
  return { top: top * H, height: h * H, width: Math.min(0.8 * W, h * H * ratio) };
}
